// frontend/src/pages/teacher/GradeSubmissionModal.js (فایل جدید)

import React, { useState, useEffect } from 'react';
import axiosInstance from '../../modules/api';
import { FaSave, FaSpinner, FaTimes, FaUserGraduate, FaPaperclip, FaCommentDots } from 'react-icons/fa';

const GradeSubmissionModal = ({ isOpen, onClose, submission, onGraded }) => {
    const [grade, setGrade] = useState('');
    const [feedback, setFeedback] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    // هر بار که مودال برای یک دانش‌آموز جدید باز می‌شود، فیلدها را پر کن
    useEffect(() => {
        if (submission) {
            setGrade(submission.grade || '');
            setFeedback(submission.feedback || '');
            setError(null); // ریست کردن خطا
        }
    }, [submission]);

    if (!isOpen || !submission) return null;

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            // API نمره‌دهی که در بک‌اند ساختیم
            await axiosInstance.patch(`/core/teacher/submissions/${submission.id}/grade/`, {
                grade: grade,
                feedback: feedback
            });
            
            // مودال را می‌بندیم
            onClose();
            // به صفحه والد اطلاع می‌دهیم که نمره‌دهی انجام شد تا لیست رفرش شود
            onGraded(); 
            
        } catch (err) {
            console.error("Grading failed:", err);
            setError(err.response?.data?.detail || "خطا در ثبت نمره.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content" style={{maxWidth: '600px'}}>
                <div className="modal-header">
                    <h2>
                        <FaUserGraduate className="ml-2" />
                        نمره‌دهی: {submission.student_info?.full_name || submission.student_info?.username}
                    </h2>
                    <button onClick={onClose} className="modal-close-btn"><FaTimes /></button>
                </div>
                
                <div className="modal-body">
                    {/* نمایش پاسخ دانش‌آموز */}
                    <div className="form-card mb-4" style={{backgroundColor: '#1f2937'}}>
                        <div className="form-header">
                            <h3 className="text-lg">پاسخ ارسال شده</h3>
                        </div>
                        <div className="form-body">
                            {submission.submission_text && (
                                <p className="text-gray-300 whitespace-pre-wrap">{submission.submission_text}</p>
                            )}
                            {submission.submission_file && (
                                <a 
                                    href={submission.submission_file} 
                                    target="_blank" 
                                    rel="noopener noreferrer"
                                    className="button button-secondary"
                                >
                                    <FaPaperclip /> دانلود فایل ضمیمه
                                </a>
                            )}
                            {!submission.submission_text && !submission.submission_file && (
                                <p className="text-gray-500">پاسخی ثبت نشده است.</p>
                            )}
                        </div>
                    </div>

                    {/* فرم نمره‌دهی */}
                    <form onSubmit={handleSubmit}>
                        {error && <div className="alert alert-danger">{error}</div>}
                        
                        <div className="form-group">
                            <label><FaCheckCircle /> نمره (از 20)</label>
                            <input
                                type="number"
                                value={grade}
                                onChange={(e) => setGrade(e.target.value)}
                                placeholder="مثلا: 18"
                                max={20}
                                min={0}
                                required
                                disabled={loading}
                                className="text-left ltr" // برای اعداد
                            />
                        </div>
                        <div className="form-group">
                            <label><FaCommentDots /> بازخورد (اختیاری)</label>
                            <textarea
                                rows="4"
                                value={feedback}
                                onChange={(e) => setFeedback(e.target.value)}
                                placeholder="توضیحات خود را برای دانش‌آموز بنویسید..."
                                disabled={loading}
                            />
                        </div>
                        
                        <div className="modal-footer" style={{paddingTop: '10px', paddingBottom: '0'}}>
                            <button type="button" className="button button-secondary" onClick={onClose} disabled={loading}>
                                انصراف
                            </button>
                            <button type="submit" className="button button-primary" disabled={loading}>
                                {loading ? <FaSpinner className="spinner" /> : <FaSave />}
                                ثبت نمره
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default GradeSubmissionModal;